module.exports = __webpack_public_path__ + "static/media/female.4e1162d1.svg";